import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=6ca02503&scoped=true&"
import script from "./follow.vue?vue&type=script&lang=js&"
export * from "./follow.vue?vue&type=script&lang=js&"
import style0 from "./follow.vue?vue&type=style&index=0&id=6ca02503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca02503",
  null
  
)

export default component.exports